<template>
  <WBDAutoCompleteSelectorFilter
    :filtered-laborer-list="''"
    :remote-list="remoteList"
    :label="label"
    :disabled="disabled"
    :on-change-event="onChangeEvent"
    :remote-option-value="selectedOptionValue"
    :model-list="modelList"
    hideSearchIcon
    :clear-event="clearEvent"
    @onOfferTypeChange="onOfferTypeChange"
  />
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import WBDAutoCompleteSelectorFilter from '@/components/common/filter/auto-complete-filter'

// Публичный (видят все)
export const ALIAS_OEC_LABORER = 'oec-laborer'
// Мои исполнители (Удаленный персонал)
export const ALIAS_OEC_REMOTE_STAFF = 'oec-remote-staff'
// Личный
export const ALIAS_OEC_PERSONAL = 'oec-personal'
// изБранных
export const ALIAS_OEC_PREFERRED = 'oec-preferred'
// Моя команда/избранных
export const ALIAS_OEC_FAVORITE = 'oec-favorite'

export const LABEL_OEC_WORKER = 'Публичный (видят все)'
export const LABEL_OEC_REMOTE_STAFF = 'Удаленный персонал (Для своих)'
export const LABEL_OEC_PERSONAL = 'Личный'
export const LABEL_OEC_FAVORITE = 'Моя команда (список избранных)'
export const LABEL_OEC_PREFERRED = 'Персональшики (Список предпочтенных )'

export default {
  name: 'WBDOfferTypeSelectorFilter',
  components: { WBDAutoCompleteSelectorFilter },
  props: {
    disabled: {
      type: Boolean,
    },
    label: {
      type: String,
      default: 'Видимость оффера'
    },
    remoteOptionValue: {
      type: String,
    },
    remoteList: {
      type: Array,
    },
  },
  data () {
    return {
      loading: false,
      clearEvent: false,
      searchQuery: null,
      selectedOptionValue: null,
      onChangeEvent: 'onOfferTypeChange',
      modelList: [
        {
          id: ALIAS_OEC_LABORER,
          title: LABEL_OEC_WORKER,
        },
        {
          id: ALIAS_OEC_REMOTE_STAFF,
          title: LABEL_OEC_REMOTE_STAFF,
        },
        {
          id: ALIAS_OEC_FAVORITE,
          title: LABEL_OEC_FAVORITE,
        },
        {
          id: ALIAS_OEC_PREFERRED,
          title: LABEL_OEC_PREFERRED,
        },
        {
          id: ALIAS_OEC_PERSONAL,
          title: LABEL_OEC_PERSONAL,
        },
      ],
      selectedModelListList: null,

    }
  },
  computed: {
    ...mapGetters({
    }),
    getModelList () {
      return this.modelList
    },
  },
  created () {
    if (this.remoteOptionValue) {
      this.selectedOptionValue = this.remoteOptionValue
    }
    this.clearEvent = this.eventNames.OFFER_TYPE_FILTER_RESET
    this.eventsBus.$on(this.clearEvent, () => {
      this.selectedModelList = null
      this.searchQuery = null
    })
  },
  methods: {
    ...mapMutations({
    }),
    ...mapActions({
    }),
    onOfferTypeChange (data) {
      this.$emit(
        this.onChangeEvent,
        data
      )
    },
  }
}
</script>
